import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import apiCalls from '../../utils/apiCalls';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getDeliveryOrderBatches } from '../../deliveryOrderBatches/deliveryOrderBatchesActions';
import AdminDeliveryDayViewDeliveryBatchTable from './adminDeliveryDayViewDeliveryBatchTable';
import { CSVLink } from 'react-csv';
import utils from '../../utils/utils';

const AdminDeliveryDayViewIndex = ({
  match,
  filteredOrderBatches,
  getDeliveryOrderBatches,
  setModalAddress,
  setModalOrderBatch,
  setModalOrder,
  deliveryOrderBatches,
  deliveryOrderBatchStatusOptions,
  selectedTemperature,
}) => {
  function createDeliveryOrderBatches() {
    apiCalls
      .createDeliveryOrderBatch({
        deliveryDayId: match.params.deliveryDayId,
      })
      .then((result) => {
        getDeliveryOrderBatches({
          deliveryDayId: match.params.deliveryDayId,
        });
      });
  }

  return (
    <div className="m-b-6">
      <div className="m-b-2">
        <Link className="btn btn-default m-r-2 m-b-2" to={`${match.url}/addresses`}>
          <FormattedMessage id={'delivery.day.view.cta.users'} />
        </Link>
        <Link className="btn btn-default m-r-2 m-b-2" to={`${match.url}/deliveries`}>
          <FormattedMessage id={'delivery.day.view.cta.deliveries'} />
        </Link>
        <button onClick={createDeliveryOrderBatches} className="btn btn-default m-r-2 m-b-2">
          <FormattedMessage id={'delivery.day.view.order.batches.create.batch'} />
        </button>
        <CSVLink
          className="btn btn-default m-r-2"
          data={getCsvData(filteredOrderBatches)}
          filename={`delivery-${match.params.deliveryDayId}.csv`}
        >
          Download CSV
        </CSVLink>
        <CSVLink
          className="btn btn-default m-r-2"
          data={getDriverCsvData(filteredOrderBatches)}
          filename={`driver-delivery-${match.params.deliveryDayId}.csv`}
        >
          Membo Driver CSV
        </CSVLink>
      </div>

      {filteredOrderBatches ? (
        <AdminDeliveryDayViewDeliveryBatchTable
          setModalOrder={setModalOrder}
          setModalOrderBatch={setModalOrderBatch}
          setModalAddress={setModalAddress}
          selectedTemperature={selectedTemperature}
          filteredOrderBatches={filteredOrderBatches}
          deliveryOrderBatchStatusOptions={deliveryOrderBatchStatusOptions}
        />
      ) : deliveryOrderBatches && deliveryOrderBatches.length === 0 ? (
        <div>
          <p>
            <FormattedMessage id={'delivery.day.view.order.batches.no.order.batches'} />
          </p>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

function getCsvData(deliveryOrderBatches) {
  if (!deliveryOrderBatches) {
    return '';
  }
  const csvHeaders = [
    'Name',
    'Address',
    'Unit',
    'Lat',
    'Lon',
    'Phone',
    'Email',
    'Delivery time',
    'Order content',
    'Line item count',
  ];

  return [
    csvHeaders,
    ...deliveryOrderBatches.map((dob) => {
      const unit = dob.address.unit || '';
      const id = dob && dob.packingId ? `${dob.packingId}` : dob ? `D${dob.id}` : '_';

      let lineItemCount = 0;
      const items = dob.orders
        .map((order) => {
          return order.items
            .map((orderItem) => {
              lineItemCount += orderItem.quantity;
              return `${orderItem.quantity > 1 ? `${orderItem.quantity} x ` : ''}${orderItem.itemName.replaceAll(
                '"',
                "'"
              )}`;
            })
            .join('\n');
        })
        .join('\n');

      return [
        `${id} - ${dob.address.customerName}`,
        dob.address.street,
        unit,
        dob.address.coordinates ? dob.address.coordinates.lat : '',
        dob.address.coordinates ? dob.address.coordinates.lon : '',
        dob.address.phoneNumber,
        dob.address.email,
        `${utils.getFormattedDateRangeFromStrings(dob.orders[0].deliveryFrom, dob.orders[0].deliveryTo)}`,
        `${items}`,
        lineItemCount,
      ];
    }),
  ];
}

function getDriverCsvData(deliveryOrderBatches) {
  if (!deliveryOrderBatches) {
    return '';
  }
  const csvHeaders = [
    'Name',
    'Address',
    'Unit',
    'Lat',
    'Lon',
    'Phone',
    'AllowedDeliveryFromHour',
    'AllowedDeliveryFromMinutes',
    'AllowedDeliveryToHour',
    'AllowedDeliveryToMinutes',
    'Content',
    'Line item count',
  ];

  return [
    csvHeaders,
    ...deliveryOrderBatches.map((dob) => {
      const unit = dob.address.unit || '';
      const id = dob && dob.packingId ? `${dob.packingId}` : dob ? `D${dob.id}` : '_';

      let lineItemCount = 0;
      const items = dob.orders
        .map((order) => {
          return order.items
            .map((orderItem) => {
              lineItemCount += orderItem.quantity;
              return `${orderItem.quantity > 1 ? `${orderItem.quantity} x ` : ''}${orderItem.itemName.replaceAll(
                '"',
                "'"
              )}`;
            })
            .join('\n');
        })
        .join('\n');

      return [
        `${id} - ${dob.address.customerName}`,
        dob.address.street,
        unit,
        dob.address.coordinates ? dob.address.coordinates.lat : '',
        dob.address.coordinates ? dob.address.coordinates.lon : '',
        dob.address.phoneNumber,
        `${utils.getFormattedDateFromString(dob.orders[0].deliveryFrom, 'HH')}`,
        `${utils.getFormattedDateFromString(dob.orders[0].deliveryFrom, 'mm')}`,
        `${utils.getFormattedDateFromString(dob.orders[0].deliveryTo, 'HH')}`,
        `${utils.getFormattedDateFromString(dob.orders[0].deliveryTo, 'mm')}`,
        `${items}`,
        lineItemCount,
      ];
    }),
  ];
}

AdminDeliveryDayViewIndex.propTypes = {
  filteredOrderBatches: PropTypes.array,
  deliveryOrderBatchStatusOptions: PropTypes.array.isRequired,
  setModalOrder: PropTypes.func.isRequired,
  setModalOrderBatch: PropTypes.func.isRequired,
  setModalAddress: PropTypes.func.isRequired,
  selectedTemperature: PropTypes.string,
};

AdminDeliveryDayViewIndex.defaultProps = {};

function mapStateToProps(state) {
  return {
    deliveryOrderBatches: state.deliveryOrderBatches.deliveryOrderBatches,
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {
  getDeliveryOrderBatches,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminDeliveryDayViewIndex));
